/* DesiTech Case Builder: shared model choices from Shopify metaobjects. */
(() => {
  'use strict';
  const init = root => {
    if (root.dataset.dtxReady === 'true') return;
    const brand = root.querySelector('[data-dtx-brand]');
    const model = root.querySelector('[data-dtx-model]');
    const caption = root.querySelector('[data-dtx-colour-caption]');
    const summary = root.querySelector('[data-dtx-summary]');
    const radios = [...root.querySelectorAll('input[name="properties[Colour]"]')];
    if (!brand || !model) return;

    const product = root.closest('.js-product');
    const form = brand.form || document.getElementById(brand.getAttribute('form')) ||
      product?.querySelector('form.js-product-form') ||
      product?.querySelector('form[action*="/cart/add"]');
    const picker = product?.querySelector('desitech-variant-picker');

    // Make external line-item-property controls participate in the product's real form.
    if (form) {
      if (!form.id) form.id = 'dtx-case-form-' + (root.dataset.productId || 'product');
      for (const input of [...radios, brand, model]) input.setAttribute('form', form.id);
    } else {
      console.warn('[DesiTech case builder] Product cart form not found; model options remain selectable.');
    }

    const colour = () => radios.find(r => r.checked)?.value || '';
    function design() {
      try {
        const values = picker?.getSelectedOptions?.().filter(Boolean);
        if (values?.length) return values.join(' / ');
      } catch (_) {}
      return product?.querySelector('h1')?.textContent?.trim() || 'Your cover';
    }
    function sync() {
      if (caption) caption.textContent = colour() || 'Choose your colour';
      if (summary) summary.textContent = brand.value && model.value && colour()
        ? [design(), colour(), brand.value + ' ' + model.value].join(' · ')
        : 'Select your exact phone model to confirm the fit.';
    }
    function populateModels(preserve = false) {
      // The Liquid-rendered option contains model data, even when JSON hydration isn't available.
      const source = brand.selectedOptions[0]?.dataset.dtxModels || '';
      const values = [...new Set(source.split('|').map(x => x.trim()).filter(Boolean))];
      const selected = preserve ? model.value : '';
      model.replaceChildren(new Option(values.length ? 'Choose your model' : 'No compatible models available', ''));
      model.options[0].disabled = true;
      for (const name of values) model.add(new Option(name, name));
      model.disabled = values.length === 0;
      model.value = values.includes(selected) ? selected : '';
      model.setCustomValidity('');
      sync();
    }
    function validate(e) {
      if (root.dataset.dtxLegacyVariants === 'true') {
        e.preventDefault();
        e.stopImmediatePropagation();
        root.querySelector('.dtx-case-builder__warning')?.scrollIntoView({block: 'center'});
        return false;
      }
      if (!form) {
        e.preventDefault(); e.stopImmediatePropagation();
        return false;
      }
      const selection = model.value;
      const allowed = (brand.selectedOptions[0]?.dataset.dtxModels || '').split('|').map(x => x.trim());
      const invalid = !colour() ? (radios[0] || brand) :
        !brand.value ? brand : (!selection || !allowed.includes(selection)) ? model : null;
      if (invalid) {
        e.preventDefault(); e.stopImmediatePropagation();
        if (invalid === model) model.setCustomValidity('Please select the exact phone model.');
        if (!invalid.disabled) { invalid.reportValidity(); invalid.focus(); }
        return false;
      }
      model.setCustomValidity('');
      return true;
    }
    brand.addEventListener('change', () => populateModels(false));
    model.addEventListener('change', () => { model.setCustomValidity(''); sync(); });
    radios.forEach(r => r.addEventListener('change', sync));
    picker?.addEventListener('change', () => setTimeout(sync, 30));

    if (form) {
      form.addEventListener('submit', validate, true);
      form.addEventListener('click', e => {
        const btn = e.target.closest('button[type="submit"],input[type="submit"],button[name="add"]');
        if (btn && btn.form === form) validate(e);
      }, true);
    }

    root.dataset.dtxReady = 'true';
    // Populate on initial page load, not just when a brand-change event fires.
    populateModels(true);
  };

  const start = () => document.querySelectorAll('[data-dtx-case-builder]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
